module.exports = __webpack_public_path__ + "img/test1.22f6cb4a.jpg";